var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUserLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "translate_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/translate_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64082 11.7525C9.74582 11.4825 9.67832 11.175 9.46832 10.965L7.90082 9.42L7.92332 9.3975C9.22832 7.9425 10.1583 6.27 10.7058 4.5H12.1608C12.5658 4.5 12.9033 4.1625 12.9033 3.7575V3.7425C12.9033 3.3375 12.5658 3 12.1608 3H7.65332V2.25C7.65332 1.8375 7.31582 1.5 6.90332 1.5C6.49082 1.5 6.15332 1.8375 6.15332 2.25V3H1.64582C1.24082 3 0.90332 3.3375 0.90332 3.7425C0.90332 4.155 1.24082 4.485 1.64582 4.485H9.28082C8.77832 5.94 7.98332 7.3125 6.90332 8.5125C6.29582 7.845 5.78582 7.1175 5.35832 6.3525C5.23832 6.135 5.02082 6 4.77332 6C4.25582 6 3.92582 6.5625 4.18082 7.0125C4.65332 7.86 5.23082 8.67 5.90582 9.42L2.62832 12.6525C2.32832 12.945 2.32832 13.425 2.62832 13.7175C2.92082 14.01 3.39332 14.01 3.69332 13.7175L6.90332 10.5L8.41832 12.015C8.80082 12.3975 9.45332 12.255 9.64082 11.7525ZM13.2782 7.5C12.8282 7.5 12.4232 7.7775 12.2657 8.205L9.51318 15.555C9.33318 16.0125 9.67818 16.5 10.1657 16.5C10.4582 16.5 10.7207 16.32 10.8257 16.0425L11.4932 14.25H15.0557L15.7307 16.0425C15.8357 16.3125 16.0982 16.5 16.3907 16.5C16.8782 16.5 17.2232 16.0125 17.0507 15.555L14.2982 8.205C14.1332 7.7775 13.7282 7.5 13.2782 7.5ZM13.2781 9.50252L12.0631 12.75H14.4931L13.2781 9.50252Z",
    fill: "#334D6E"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserLanguage);
export default __webpack_public_path__ + "static/media/icon-user-language.12ea0a100f3ee4666fd5a90d9dc6a412.svg";
export { ForwardRef as ReactComponent };